import { getBenedictOutcome } from './benedicts';
import { getBiuretOutcome } from './biuret';
import { getDcpipOutcome } from './dcpip';
import { getEmulsionOutcome } from './emulsion';
import { getHydrolysisOutcome } from './hydrolysis';
import { getIodineOutcome } from './iodine';
import type { FoodInput, FoodTestId, FoodTestOutcome, ProcedureState } from './types';

/** Dispatches a food sample and recorded procedure to the corresponding pure test model. */
export function getTestOutcome(food: FoodInput, test: FoodTestId, procedure: ProcedureState): FoodTestOutcome {
  switch (test) {
    case 'reducing-sugar': return getBenedictOutcome(food, procedure);
    case 'non-reducing-sugar': return getHydrolysisOutcome(food, procedure);
    case 'starch': return getIodineOutcome(food, procedure);
    case 'protein': return getBiuretOutcome(food, procedure);
    case 'lipid': return getEmulsionOutcome(food, procedure);
    case 'vitamin-c': return getDcpipOutcome(food, procedure);
    default: {
      const unreachableTest: never = test;
      throw new RangeError(`Unsupported food test: ${unreachableTest}`);
    }
  }
}